import { getItemCookie } from "./cookie";

/**
 * Người dùng được coi là đã đăng nhập khi có token thật trong cookie `token`
 * (do host MyID set khi vào app). Đây là tín hiệu BỀN — còn nguyên sau khi
 * reload trang.
 *
 * Lưu ý: config/service.js có một token fallback CỨNG chỉ dùng để gọi API lúc
 * dev; fallback đó KHÔNG ghi cookie nên KHÔNG được tính là đã đăng nhập ở đây.
 */
export const hasAuthCookie = () => Boolean(getItemCookie("token"));
